export const SHOWCASE_CONTENT = {
  eyebrow: { es: "Galería", en: "Showcase", pt: "Galeria" },
  title: { es: "Nuestra operación en movimiento", en: "Our operation in motion", pt: "Nossa operação em movimento" },
  sub: {
    es: "Cinco frentes, un mismo estándar de excelencia.",
    en: "Five fronts, one standard of excellence.",
    pt: "Cinco frentes, um mesmo padrão de excelência.",
  },
};

export const SHOWCASE_SLIDES = [
  {
    id: "container_cargo",
    image: "https://images.unsplash.com/photo-1590497008432-598f04441de8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxzaGlwcGluZyUyMGNvbnRhaW5lciUyMHBvcnQlMjBkdXNrJTIwbmlnaHQlMjBjaW5lbWF0aWN8ZW58MHx8fHwxNzkxNjgxNDc1fDA&ixlib=rb-4.1.0&q=85",
    label: { es: "Carga de Contenedores", en: "Container Cargo", pt: "Carga de Contêineres" },
    desc: {
      es: "Movimiento portuario y marítimo de contenedores con control total.",
      en: "Port and maritime container handling with full control.",
      pt: "Movimentação portuária e marítima de contêineres com controle total.",
    },
  },
  {
    id: "private_jet",
    image: "https://images.unsplash.com/photo-1474302770737-173ee21bab63?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxwcml2YXRlJTIwamV0JTIwbmlnaHQlMjB0YXJtYWMlMjBkdXNrJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzkxNjgxNDc1fDA&ixlib=rb-4.1.0&q=85",
    label: { es: "Aviación Privada", en: "Private Aviation", pt: "Aviação Privada" },
    desc: {
      es: "Coordinación de traslados ejecutivos de máximo nivel.",
      en: "Coordination of top-tier executive transfers.",
      pt: "Coordenação de traslados executivos de alto nível.",
    },
  },
  {
    id: "executive_fleet",
    image: "https://images.unsplash.com/photo-1758223725140-3855ec687a16?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxibGFjayUyMGx1eHVyeSUyMHN1diUyMG5pZ2h0JTIwY2l0eSUyMGZsZWV0JTIwY29udm95fGVufDB8fHx8MTc5MTY4MTQ4MHww&ixlib=rb-4.1.0&q=85",
    label: { es: "Transporte Ejecutivo", en: "Executive Transport", pt: "Transporte Executivo" },
    desc: {
      es: "Flota de lujo para ejecutivos, con Disimil como aliado.",
      en: "Luxury fleet for executives, with Disimil as a partner.",
      pt: "Frota de luxo para executivos, com a Disimil como parceira.",
    },
  },
  {
    id: "property_management",
    image: "https://images.unsplash.com/photo-1612283157924-f0e11f121c3f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBidWlsZGluZyUyMGR1c2slMjBhcmNoaXRlY3R1cmUlMjBuaWdodHxlbnwwfHx8fDE3OTE2ODE0NzV8MA&ixlib=rb-4.1.0&q=85",
    label: { es: "Inmuebles en Administración", en: "Properties Under Management", pt: "Imóveis em Administração" },
    desc: {
      es: "Custodia y administración patrimonial de activos inmobiliarios.",
      en: "Safekeeping and asset administration of real estate.",
      pt: "Custódia e administração patrimonial de ativos imobiliários.",
    },
  },
  {
    id: "warehouse_logistics",
    image: "https://images.unsplash.com/photo-1694875522449-e852b63be76d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHx3YXJlaG91c2UlMjBhaXNsZSUyMHJhY2tzJTIwaW50ZXJpb3IlMjBkYXJrJTIwbmlnaHQlMjBsaWdodGluZ3xlbnwwfHx8fDE3OTE2ODE0ODl8MA&ixlib=rb-4.1.0&q=85",
    label: { es: "Logística de Almacén", en: "Warehouse Logistics", pt: "Logística de Armazém" },
    desc: {
      es: "Almacenamiento, inventario y distribución punto a punto.",
      en: "Storage, inventory, and end-to-end distribution.",
      pt: "Armazenagem, estoque e distribuição ponta a ponta.",
    },
  },
];
